module.exports = __webpack_public_path__ + "static/media/severity-yellow.b03e6044.svg";